import { types } from "../types/types";

export const mensajesReducer = (state={}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
